/* unplugin-vue-components disabled */import { render } from "./videoMain.vue?vue&type=template&id=f9b6fb58&scoped=true&ts=true"
import script from "./videoMain.vue?vue&type=script&lang=ts"
export * from "./videoMain.vue?vue&type=script&lang=ts"

import "./videoMain.vue?vue&type=style&index=0&id=f9b6fb58&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b6fb58"],['__file',"src/views/videoDetail/cpns/videoMain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9b6fb58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9b6fb58', __exports__)) {
    console.log('reload')
    api.reload('f9b6fb58', __exports__)
  }
  
  module.hot.accept("./videoMain.vue?vue&type=template&id=f9b6fb58&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('f9b6fb58', render)
  })

}


export default __exports__